<script lang="ts">
  export let title: string;
  export let colour = "";
  export let bgColour = "";
  export let className = "";
  export let hide = "";

  function showoption(hide: string) {
    if (hide === "mob") {
      return "desk-only";
    } else if (hide === "desk") {
      return "mob-only";
    } else {
      return "";
    }
  }
  // In some place thi components is use passing the colour, somewhere not,
  // Where is not we want to use the class of the components so leave the check for colour
  function genStyle() {
    if (colour) {
      const retVal: string[] = [];
      colour && retVal.push(`color:${colour}`);
      bgColour && retVal.push(`background-color:${bgColour}`);
      return retVal.join(";");
    }
  }
  const classes = ["sugg-wrapper", "pf-500", className.toLowerCase().replaceAll(" ", "-"), showoption(hide)].join(" ");
</script>

<span class={classes} style={genStyle()}>
  {(title || "").replaceAll("-", " ")}
</span>

<style lang="scss">
  .sugg-wrapper {
    padding: 0.3125em 0.625em;
    border-radius: 2.5em;
    font-size: 0.8125em;
    line-height: calc(0.8125em + 0.3125em * 2);
    color: #fff;
    text-transform: capitalize;

    &.e-tickets {
      background: #8520a9;
    }
    &.mobile {
      background: #23a920;
    }
    &.mobile-link {
      background: #8520a9;
    }
    &.season-cards {
      background: #000;
    }
    &.paper-tickets {
      background: #d99d04;
    }
    &.seated-together {
      border: 1px solid #23a920;
      background: rgba(35, 169, 32, 0.2);
      color: #007404;
    }
    &.single-seats {
      border: 1px solid #8690e4;
      background: rgba(212, 215, 252, 0.2);
      color: #8690e4;
    }
    &.featured {
      background: pink;
    }
    &.sale-ending-soon {
      background: #8520a9;
    }
    &.price-increase {
      background: #d99d04;
    }
    &.excellent-value {
      background: #23a920;
    }
    &.tickets-selling-fast {
      background: #d99d04;
    }
    &.popular-game {
      background: #23a920;
    }
  }
</style>
